<template>
  <div>
    <social-sharing
      :url="url"
      :title="title"
      :description="description"
      :quote="quote"
      inline-template
    >
      <div class="d-flex social-container">
        <network network="facebook">
          <font-awesome-icon
            id="icon-fb"
            class="social-icon"
            :icon="['fab', 'facebook-square']"
          />
        </network>
        <network network="twitter">
          <font-awesome-icon
            id="icon-twitter"
            class="social-icon"
            :icon="['fab', 'twitter']"
          />
        </network>
        <network network="linkedin">
          <font-awesome-icon
            id="icon-linkedin"
            class="social-icon"
            :icon="['fab', 'linkedin']"
          />
        </network>
      </div>
    </social-sharing>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    quote: {
      type: String,
      default: ""
    },
  }
}
</script>

<style lang="scss">
  .social-container {
    justify-content: space-evenly;

    .social-icon {
      font-size: 2.2rem;
      padding: 5px;
      cursor: pointer;
      color: #009090;

      &:hover {
        background: #e1e1e1;
      }
    }
  }
</style>
